import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ActiveStatus = styled.div`
  color: ${props => props.theme.valid};
  text-transform: capitalize;
  font-size: 12px;
  line-height: 24px;
`;

const InactiveStatus = styled(ActiveStatus)`
  color: ${props => props.theme.invalid};
`;

const NullStatus = styled(ActiveStatus)`
  color: ${props => props.theme.matchScore.medium.color};
`;
const WarningStatus = styled(ActiveStatus)`
  color: ${props => props.theme.matchScore.low.color};
`;

const styleMap = {
  DELETION_PENDING: WarningStatus,
  INGESTED: ActiveStatus,
  active: ActiveStatus,
  inactive: InactiveStatus,
};

function StatusButton({ status }) {
  const StatusEl = styleMap[status];

  if (!StatusEl || !status) {
    return <NullStatus>&#9679;&nbsp;{status}</NullStatus>;
  }
  return <StatusEl>&#9679;&nbsp;{status}</StatusEl>;
}

StatusButton.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusButton;
